import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { push } from "react-router-redux";
import IntlMessages from "util/intlMessages";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { adminAPI } from "redux/api";
import { apiUrls, formLink } from "./init";
import ContentData from "./Data";

const { api } = adminAPI.actions;

const AddSource = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [content, setContent] = useState({});
  const [disabled, setDisabled] = useState(false);
  const toggleModal = () => setOpenModal(!openModal);
  const dispatch = useDispatch();

  const addHandler = () => {
    const onSuccess = (body) => {
      dispatch(push(formLink(body)));
    };
    props.addContent({ body: content }, { onSuccess });
  };

  useEffect(() => {
    setDisabled(!content.name);
  }, [content]);

  useEffect(() => {
    setContent({});
  }, [openModal]);

  return (
    <>
      <i className="fa fa-plus-square" onClick={toggleModal} />

      {openModal && (
        <Modal isOpen={openModal} centered size="lg" toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <IntlMessages id="Specials.Casts.Add" />
          </ModalHeader>
          <ModalBody>
            <ContentData {...{ content, setContent }} />

            <div className="form-group">
              <button
                type="button"
                className="form-control c-primary"
                disabled={disabled}
                onClick={addHandler}
              >
                <IntlMessages id="save" />
              </button>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default connect(null, {
  addContent: api.post(apiUrls.list),
})(AddSource);
